import React from 'react'
import styled from 'styled-components'

import { border } from 'styles'

import Rooms from 'components/chat/Rooms'
import Messages from 'components/chat/Messages'

const Wrapper = styled.div`
  flex-grow: 1;
  display: flex;
  max-width: 1200px;
  width: 100%;
  align-self: center;

  @media (min-width: 1200px) {
    border-right: ${border};
    border-left: ${border};
  }
`

const Error = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

class Chat extends React.Component {
  componentDidMount() {
    document.body.style.backgroundColor = 'white'
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = ''
  }

  render() {
    return (
      <Wrapper>
        <Rooms
          heading
          roomIds={this.props.roomIds}
          activeRoom={this.props.activeRoom}
          selectRoom={this.props.selectRoom}
        />
        {this.props.roomIds.includes(this.props.activeRoom) ? (
          <Messages heading roomId={this.props.activeRoom} />
        ) : (
          <Error>
            <div>Det ser ikke ut som du har tilgang til denne chatten.</div>
            <div>Kanskje du er logget inn med feil bruker?</div>
          </Error>
        )}
      </Wrapper>
    )
  }
}

export default Chat



// WEBPACK FOOTER //
// ./src/pages/Chat/LargeChat.js